import * as React from "react"

const defaultProps = {
    height: 13.314,
    width: 11.353,
    fill: 'none',
} 

function SvgHomeIcon({ height, width, fill }) {
    
    return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      
    >
      <path d="M0 4.415L5.676 0l5.676 4.415v6.938a1.261 1.261 0 01-1.261 1.261h-8.83A1.261 1.261 0 010 11.353z" fill={fill}/>
      <path
        d="M3.784 12.614V6.307h3.784v6.307"
        fill={fill}
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      />
    </svg>
  )
}

SvgHomeIcon.defaultProps = defaultProps;

export default SvgHomeIcon
